import React, { useCallback, useEffect, useState } from 'react';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import SelectDropdown from 'components/base/select-dropdown';
import { IngredientListType, IngredientType } from 'models/pricing.model';
import { ENUM_UNIT } from 'models/common.model';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { debounce } from 'utils/functions';

type Props = {
  itemIndex: number;
  ingredient_name: string;

  type: 'ingredients' | 'packaging';
  handleInputChange: (
    itemIndex: number,
    value: string | number | ENUM_UNIT,
    name: keyof IngredientType,
    type: 'ingredients' | 'packaging',
    ingredient?: IngredientListType
  ) => void;
};
const IngredientSelect = ({ itemIndex, handleInputChange, ingredient_name, type }: Props) => {
  const [search, setSearch] = useState('');
  const [ingredients, setIngredients] = useState<IngredientListType[]>([]);

  const fetchIngredients = async (searchString: string) => {
    try {
      const response = await apiService.get(`ingredients`, {
        params: { name: searchString, page: 1 }
      });
      if (response) {
        setIngredients(response?.data?.results);
      }
    } catch (err: any) {
      toast(
        <ToastMessage
          message={err.response?.data?.message || 'Error fetching vendors'}
          type='error'
        />
      );
    }
  };

  const debounceFetchIngredients = useCallback(debounce(fetchIngredients, 500), []);

  useEffect(() => {
    debounceFetchIngredients(search);
  }, [search]);
  return (
    <SelectDropdown
      hasSearch
      placeholder='Search ingredients'
      value={ingredient_name}
      setValue={(item) => {
        handleInputChange(itemIndex, item.name, 'ingredient_name', type, item);
      }}
      onChange={(val) => {
        setSearch(val);
      }}
      options={ingredients}
    />
  );
};
export default IngredientSelect;
